/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Leonid Khramov, bohdev
 */
import React from 'react'
import { connect } from 'react-redux'
import Dialog from '../../components/Dialog.js'


import './about.css'
import traceIDBanner from '../../assets/img/trace-profile-logo.svg'

class AboutTraceIDDialog extends Dialog {

    get title() {
        return (<h2>About Trace iD</h2>)
    }

    get dismissUrl() {
        return window.location.hash.replace(/^#\//gi, '/').replace(/\/about\/traceid$/gi, '')
    }

    get content() {
        return (
            <div className="about-traceid">
                <h3>Trace iD is only open to beta testers right now.</h3>
                <p>We’ve added {this.props.email} to the waiting list and you will be notified as soon as it becomes available. </p>
                <div className="profile-logo">
                    <img src={traceIDBanner} alt="" />
                </div>
            </div>
        )
    }
}

const mapStateToPropsRU = (state, pageProps) => {
    let email = 'you'
    if (state.user && state.user.value && state.user.value.email) {
        email = state.user.value.email
    }

    return {
        email
    }
}

const mapDispatchToPropsRU = (dispatch) => {
    return {
    }
}

export const AboutTraceID = connect(
    mapStateToPropsRU,
    mapDispatchToPropsRU
)(AboutTraceIDDialog)
